export default __webpack_public_path__ + "static/media/card-project1.797436a4.jpg";